import { Check, ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useServerFn } from '@tanstack/react-start'
import { signInWithGoogleFn } from '@/server/functions/auth'
import { toast } from 'sonner'
import { getCheckoutUrl } from '@/server/functions/payments'
import { getEnvServer } from '@/lib/utils'


interface PricingProps {
  currentUser?: any
}
type TPlan = 'STARTER_PRODUCT_ID' | 'PRO_PRODUCT_ID'
export function Pricing({ currentUser }: PricingProps) {
  const signIn = useServerFn(signInWithGoogleFn)

  const handleGetStarted = async (plan: TPlan) => {
    try {
      console.log('a');

      const productId = await getEnvServer({ data: plan })
      console.log('b');
      // 1. Set cookies for the chosen plan

      // 2. Define the target checkout URL

      if (!currentUser) {
        try {
          await signIn({ data: { redirect: `/checkout?productId=${productId}` } })
        } catch (error) {
          console.error('Sign-in failed:', error)
          toast.error('Failed to sign in. Please try again.')
        }
      } else {
        console.log('c');
        const res = await getCheckoutUrl({ data: { productId, userId: currentUser.$id } })
        console.log('d');
        if (res) {
          window.location.href = res.href
        }
      }
    } catch (error) {
      console.log('Failed to getstarted', error);

    }
  }

  const plans = [
    {
      name: 'Starter',
      price: 29,
      productId: 'STARTER_PRODUCT_ID',
      credits: 15,
      description: 'Perfect for personal automation',
      features: [
        '1 AI agent active',
        '1,500 monthly credits',
        'Standard execution speed',
        'Google & Slack integrations',
        'Web search capabilities',
        'Email support',
      ],
    },
    {
      name: 'Pro',
      price: 59,
      productId: 'PRO_PRODUCT_ID',
      credits: 45,
      popular: true,
      description: 'For power users & small teams',
      features: [
        '5 AI agents active',
        '4,500 monthly credits',
        'Priority execution speed',
        'Long-term persistent memory',
        'Advanced file & data analysis',
        '24/7 Priority support',
      ],
    },
  ]

  return (
    <section id="pricing" className="min-h-screen py-12 md:py-24 bg-slate-950 relative flex items-center">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-white tracking-tight">
            Simple, <span className="text-primary">transparent</span> pricing
          </h2>
          <p className="text-base md:text-lg text-slate-400 max-w-xl mx-auto">
            Choose the plan that fits your needs. Scale your AI assistant presence effortlessly.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`relative bg-slate-900 rounded-3xl p-8 border-2 transition-all duration-300 ${plan.popular
                ? 'border-primary shadow-[0_0_40px_rgba(245,61,16,0.1)] scale-105 z-10'
                : 'border-slate-800 hover:border-slate-700'
                }`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary text-white text-[10px] font-bold uppercase tracking-widest py-1 px-4 rounded-full">
                  Most Popular
                </div>
              )}

              <div className="mb-8">
                <h3 className="text-xl font-bold text-white mb-2">{plan.name}</h3>
                <p className="text-sm text-slate-400 mb-6">{plan.description}</p>
                <div className="flex items-baseline gap-1">
                  <span className="text-5xl font-bold text-white">${plan.price}</span>
                  <span className="text-slate-500 text-sm">/month</span>
                </div>
              </div>

              <div className="space-y-4 mb-10">
                {plan.features.map((feature) => (
                  <div key={feature} className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 text-primary" />
                    </div>
                    <span className="text-sm text-slate-300">{feature}</span>
                  </div>
                ))}
              </div>

              <Button
                className={`w-full py-4 h-auto rounded-2xl text-base font-bold transition-all ${plan.popular
                  ? 'bg-primary text-white hover:bg-primary/90'
                  : 'bg-white text-slate-950 hover:bg-slate-100'
                  }`}
                onClick={() => handleGetStarted(plan.productId as TPlan)}
              >
                Get Started
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>

              <p className="text-center text-[10px] text-slate-500 mt-4">
                No hidden fees · Cancel anytime
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="mt-16 text-center">
          <p className="text-xs text-slate-500">
            Need a custom plan? <a href="https://x.com/sahil_builds" className="text-primary hover:underline">Contact sales</a> for enterprise solutions.
          </p>
        </div>
      </div>
    </section>
  )
}
